import styled from 'styled-components';
import { COLORS } from '../../../constants/radar';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  background: white;
  padding: 20px;
  border-radius: 8px;
  min-width: 300px;
  max-width: 500px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
`;

export const Title = styled.h2`
  margin: 0 0 20px 0;
  color: ${COLORS.PRIMARY};
  font-size: 1.2rem;
`;

export const Message = styled.p`
  margin: 0 0 20px 0;
  color: ${COLORS.SECONDARY};
  font-size: 0.9rem;
  line-height: 1.4;
`;

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
`;

export const Button = styled.button`
  padding: 8px 16px;
  border-radius: 4px;
  border: none;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s ease;

  ${props => props.variant === 'primary' && `
    background-color: ${props.$color || COLORS.PRIMARY};
    color: white;
    
    &:hover {
      background-color: ${props.$color ? props.$color + 'DD' : COLORS.SECONDARY};
    }
  `}

  ${props => props.variant === 'secondary' && `
    background-color: ${COLORS.BACKGROUND};
    color: ${COLORS.PRIMARY};
    
    &:hover {
      background-color: ${COLORS.BACKGROUND_DARK};
    }
  `}
`; 